import { useMutation } from "@tanstack/react-query";
import services from "../services";

interface DeleteDeliveryOptionInput {
  estimateNo: string;
  splitId: string;
  optionId: string;
}

export const useDeleteDeliveryOption = () => {
  return useMutation({
    mutationKey: ["deliveryOption", "delete"],
    mutationFn: (data: DeleteDeliveryOptionInput) =>
      services.deleteDeliveryOptionInEstimateSplit(
        data.estimateNo,
        data.splitId,
        data.optionId,
      ),
  });
};
